<template>
  <div
    id="timeline-list-menu"
    v-on:contextmenu.prevent
  >
    <v-menu
      absolute offset-y transition="false"
      ref="timelineListMenu"
      v-model="$data.$_menuVisibility"
      v-bind:position-x="$data.$_menuPositionX"
      v-bind:position-y="$data.$_menuPositionY"
    >
      <template v-slot:activator="{ on: { keydown }, attrs, value }">
        <div
          id="timeline-clickable-area"
          ref="timelineClickableArea"
          tabindex="-1"
          v-bind="attrs"
          v-on:keydown="$_onKeydown(value, keydown, $event)"
        >
        </div>
      </template>
      <v-list dense>
        <v-list-item
          v-for="(menuContent, menuContentIdx) in $data.$_menuContents"
          v-bind:key="menuContentIdx"
          v-bind:disabled="menuContent.disabled"
          v-on:click.left="$_onClickMenuContent(menuContent)"
        >
          <v-list-item-title>{{ menuContent.name }}</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </div>
</template>

<style scoped>
#timeline-list-menu {
  position: relative;
  width: 100%;
  height: 100%;
}

#timeline-clickable-area {
  outline: none;
  user-select: none;
  position: absolute;
  top: 0;
  left: 0;
}
</style>

<script>
export default {
  watch: {
    '$data.$_menuVisibility'(menuVisibility) {
      if (!menuVisibility) {
        this.$refs.timelineClickableArea.blur();
      }
    },
  },
  
  data() {
    return {
      $_menuContents: [],
      $_menuPositionX: 0,
      $_menuPositionY: 0,
      $_menuVisibility: false,
    };
  },
  
  methods: {
    /* private */
    $_onKeydown(isMenuOpen, onKeydownCallback, event) {
      if (isMenuOpen) {
        onKeydownCallback(event);
      }
    },
    
    $_onClickMenuContent(menuContent) {
      menuContent.callback(menuContent.name);
    },
    
    /* public */
    openMenu(event, menuContents) {
      this.$refs.timelineClickableArea.focus();
      this.$data.$_menuContents = menuContents;
      this.$data.$_menuPositionX = event.clientX;
      this.$data.$_menuPositionY = event.clientY;
      this.$data.$_menuVisibility = true;
    },
  }
};
</script>